import { render, staticRenderFns } from "./GroupTrainingsModal.vue?vue&type=template&id=2f5b4ed2&scoped=true&"
import script from "./GroupTrainingsModal.vue?vue&type=script&lang=js&"
export * from "./GroupTrainingsModal.vue?vue&type=script&lang=js&"
import style0 from "./GroupTrainingsModal.vue?vue&type=style&index=0&id=2f5b4ed2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5b4ed2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog,VIcon})
